// Types
import type { useParams, usePathname } from 'next/navigation';

// Lib
import { layoutHeaderDisabled } from '@/lib/layout/layoutHeaderDisabled';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

type GetIsHeaderManageProfilesDisabledProps = {
    pathname: ReturnType<typeof usePathname>;
    params: ReturnType<typeof useParams>;
};

export function getIsHeaderManageProfilesDisabled({
    pathname,
    params = {}
}: GetIsHeaderManageProfilesDisabledProps) {
    const urlsFormatted = formatUrls(layoutHeaderDisabled, params);
    return urlsFormatted.includes(pathname);
}
